import { storage } from 'APP/packages/storage';
import { IChatBackgroundCustomItem } from 'APP/store/Appearance/Appearance.types';
import Entities from 'STORE';

export function loadChatBackgroundsCustom(): void {
  const userId = Entities.usersStore.myId;
  if (!userId) {
    return;
  }

  const backgrounds = storage.chatBackgroundsCustom.get(userId);

  const backgroundsNormalizedMap: Record<string, IChatBackgroundCustomItem> = Object.fromEntries(
    Object.entries(backgrounds).map(([stringTs, url]) => [
      stringTs,
      { id: stringTs, url, timestamp: Number(stringTs) },
    ])
  );

  Entities.appearance.setCustomChatBackgrounds(backgroundsNormalizedMap);
}
